import styled from "styled-components";
import {Dropdown, Form} from "react-bootstrap";

export const DropdownToggle = styled(Dropdown.Toggle)`
  margin: 0;
  padding: 0;
  opacity: 0;
  height: 0;
`

export const SelectComponentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`

export const SelectComponentControl = styled(Form.Control)`
  caret-color: transparent;
`

export const SelectComponentDrop = styled.div`
    
`

export const SelectComponentDropName = styled.p`
    margin: 0;
  padding: 0;
    
    
`

export const SelectComponentDropPath = styled.p`
  margin: 0;
  padding: 0;
    color: gray;
  font-size: 12px;
`
